module.exports = __webpack_public_path__ + "static/media/one.21fd0a8c.png";